import React from 'react';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { I18nextProvider } from 'react-i18next';
import { i18nInit } from '../i18n';
import { SupportModal as SupportModalBase } from '../components/modals/support-modal/support-modal';
import type { Origin } from '../components/manage-installed-apps-page';

interface ISupportModalProps extends Partial<WithTranslationProps> {
  manageAppsStaticsUrl: string;
  closeModal(): void;
  app: any;
  locale: string;
  baseUrl: string;
  msId: string;
  origin: Origin;
  authorizationHeader: string;
  clickSource?: string;
  pageName?: string;
  showUserActionNotification?(options: any): void;
}

export class SupportModal extends React.Component<ISupportModalProps, any> {
  render() {
    const baseUrl = this.props.baseUrl;
    const origin = this.props.origin;
    const msId = this.props.msId;
    const authorizationHeader = this.props.authorizationHeader;
    const handleClose = this.props.closeModal;
    return (
      <div>
        <I18nextProvider i18n={i18nInit({ locale: this.props.locale })}>
          <SupportModalBase
            app={this.props.app}
            msId={msId}
            origin={origin}
            closeModal={handleClose}
            authorizationHeader={authorizationHeader}
            baseUrl={baseUrl}
            clickSource={this.props.clickSource}
            pageName={this.props.pageName}
            showUserActionNotification={this.props.showUserActionNotification}
          />
        </I18nextProvider>
      </div>
    );
  }
}
